import React from "react";
import { TextField } from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import EventFeaturesItem from "./EventFeaturesItem";
import { getEventByStatus } from "../../api/event";
import { branch } from "../../utils/Constant";

const EventFeatures = () => {
  const [events, setEvents] = React.useState([]);

  React.useEffect(() => {
    const fetchData = async () => {
      const result = await getEventByStatus(0);
      setEvents(result);
    };
    fetchData();
  }, []);

  return (
    <section className="event_features_area mb-4">
      {events && events.length > 0 && (
        <div className="container">
          <div className="hosting_title security_title text-center">
            <h2 className="wow fadeInUp" data-wow-delay="0.2s">
              <span>Aktiviti-aktiviti</span>yang sedang dianjurkan
            </h2>
            <div>
              <Autocomplete
                options={branch}
                getOptionLabel={option => option.title}
                renderInput={params => (
                  <TextField
                    {...params}
                    label="Cawangan Gema"
                    margin="normal"
                    variant="outlined"
                  />
                )}
              />
            </div>
          </div>
          <div className="row event_features_inner">
            {events.map(event => (
              <EventFeaturesItem
                url={`/event?id=${event.eventId}`}
                image="leader.png"
                title={`${event.name}`}
                ptext={`${event.description}`}
                poster={`${event.posterUrl}`}
                btn="Lihat"
              />
            ))}
          </div>
        </div>
      )}
    </section>
  );
};
export default EventFeatures;
